// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
import KitPanel from 'components/kits/overview/KitPanel';

class KitsOverviewPage extends Page {
  constructor(props) {
    super(props);

    this.SCHOOLYEAR_CURR = (new Date()).getFullYear();
    this.SCHOOLYEAR_MIN = 2010;
    this.SCHOOLYEAR_MIN_PROBLEMS = (new Date()).getFullYear() - 2; // don't fetch problems if older

    this.state = {
      groups: [],
      products: {},
      details: {},
      problems: {},

      filters: {
        schoolyears: [this.SCHOOLYEAR_CURR],

        locations: [],

        projects: [],
        productGroups: [],
        products: [],

        operators: ['OR', 'OR']
      },

      fetching: false
    };

    this.handleFilters = this.handleFilters.bind(this);
  }

  componentDidMount() {
    // this.fetchReport(this.SCHOOLYEAR_CURR, () => {
    //   for (let schoolyear=this.SCHOOLYEAR_CURR - 1; schoolyear>=this.SCHOOLYEAR_MIN; schoolyear--) {
    //     this.fetchReport(schoolyear);
    //   }
    // });
  }

  componentWillUnmount() {
  }

  handleFilters(data) {
    this.setState({
      filters: data
    });
  }

  render() {
    let output = [];
    let numGroups = 0;
    let numKits = 0;

    if (this.props.appData.cache && this.props.appData.cache.reports && this.props.appData.cache.reports.kitRequests) {
      const report = this.props.appData.cache.reports.kitRequests;

      report.group_data.forEach((groupData) => {
        const group = groupData.group;
        let kitsOutput = [];

        groupData.kit_data.forEach((kitData) => {
          if (kitData.kit !== null && this.state.filters.schoolyears.indexOf(kitData.kit.schoolyear) != -1) {
            const kit = kitData.kit;

            kitsOutput.push(
              <KitPanel data={kitData} />
            );
          }
        });

        if (kitsOutput.length) {
          numGroups++;
          numKits += kitsOutput.length;

          output.push(
            <div className="mt-4">
              {
                <h2 style={{zoom: '115%'}}>
                  {group.name}
                </h2>
              }

              {kitsOutput}
            </div>
          );
        }
      });
    }

    return (
      <div>
        <PageHeader>
          <MainHeading
            icon="fa fa-gift"
            title="Kit + ordini"
            descr="Panoramica kit educativi e relative richieste"
          />

          <FiltersToolbar
            filters={['schoolyears']}
            collapsable={false}

            onChange={this.handleFilters}

            data={this.state.filters}
            appData={this.props.appData}
          />
        </PageHeader>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: 'Kit educativi' + (this.state.filters.schoolyears.length ? ' A/S ' + this.state.filters.schoolyears.map((schoolyear) => {
              return ' ' + schoolyear + '/' + (parseInt(String(schoolyear).substring(2, 4)) + 1);
            }) : ''),
            descr: this.props.appData.cache.reports.kitRequests ? '(' + numKits + ' kit in  ' + numGroups + ' gruppi)' : ''
          }}

          status={{
            fetching: this.getStatus() == this.STATUS_BUSY,
            errors: null
          }}
        >
          {
            output.length ? output : (
              this.state.filters.schoolyears.length ?
                <Spinner message="Loading..." /> :
                <span>
                  <i className="fa fa-exclamation-triangle" /> Seleziona anno scolastico per continuare
                </span>
            )
          }
        </PageDataWrapper>
      </div>
    );
  }
}

export default KitsOverviewPage;



// WEBPACK FOOTER //
// ./src/pages/kits/KitsOverviewPage.js